export default __webpack_public_path__ + "media/time-tracking.87eb238e9512d84b0f7f5b0a5f6b6c9b.svg";